import type { FunctionComponent } from "react";
import {
  Price,
  SkeletonLoader,
  Tag,
  type TagColor,
  type SkeletonLoaderProps,
} from "@kanda-libs/ks-design-library";
import type { Payment } from "@kanda-libs/ks-frontend-services";
import usePaymentCellProps from "components/payment/PaymentTable/PaymentCell/usePaymentCellProps";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/payment/PaymentTable/PaymentCell/constants";

export interface PaymentCellProps {
  amount: number;
  status?: Payment["status"];
  type?: string;
  id?: string;
  isLoading?: boolean;
  skeletonClassName?: string;
  skeletonProps?: SkeletonLoaderProps;
}

const PaymentCell: FunctionComponent<PaymentCellProps> = function ({
  amount,
  type = "loan",
  status = "upaid" as Payment["status"],
  id = "unpaid",
  isLoading = false,
  skeletonClassName = "",
  skeletonProps = {},
}) {
  const { priceColor, tagColor, classNames, searchWords } = usePaymentCellProps(
    status,
    type
  );

  return (
    <SkeletonLoader
      isLoading={isLoading}
      className={skeletonClassName}
      {...skeletonProps}
      afterLoading={
        <div className="flex flex-col max-w-full">
          <div className="flex flex-row mb-1">
            <Price amount={amount} color={priceColor} {...classNames} />
            <Tag
              label={type}
              color={tagColor as TagColor}
              size={21}
              className="my-auto ml-2 mr-auto"
              variant="solid"
            />
          </div>
          <Highlighter
            {...HIGHLIGHT_PROPS}
            searchWords={searchWords}
            textToHighlight={id || ""}
            className="text-12-18"
          />
        </div>
      }
    />
  );
};

export default PaymentCell;
